export default __webpack_public_path__ + "static/media/camara.22125e96.svg";